import React from "react";
import middleware from "./middleware/middleware";
import ManageAllAskTransaction from "../component/sections/finance/manage/AllAskTransaction";
import ManageInfoAskTransaction from "../component/sections/finance/manage/InfoAskTransaction";
import AllLogWalletPublisher from "../component/sections/finance/manage/AllLogWalletPublisher";
import AllLogScorePublisher from "../component/sections/finance/manage/AllLogScorePublisher";
import AllTransactionManually from "../component/sections/finance/manage/AllTransactionManually";
import AddTransactionManually from "../component/sections/finance/manage/AddTransactionManually";
import ManageAllWalletLogPosition from "../component/sections/finance/manage/AllWalletLogPosition";
import ManageAllScoreLogPosition from "../component/sections/finance/manage/AllScoreLogPosition";
import AllTransactionScoreToWalletAdvertiser from "../component/sections/finance/manage/AllTransactionScoreToWalletAdvertiser";

const sitesRoutes = [
  {
    path: "/finance/manage/ask-transaction/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllAskTransaction />,
        "ManageAllAskTransaction"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/ask-transaction/info/:askTransactionID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageInfoAskTransaction />,
        "ManageInfoAskTransaction"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/all-log-wallet-publisher",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllLogWalletPublisher />,
        "AllLogWalletPublisher"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/all-log-score-publisher",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllLogScorePublisher />,
        "AllLogScorePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/transaction-manually/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTransactionManually />,
        "AllTransactionManually"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/transaction-manually/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddTransactionManually />,
        "AddTransactionManually"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/all-wallet-log-position",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllWalletLogPosition />,
        "ManageAllWalletLogPosition"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/all-score-log-position",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllScoreLogPosition />,
        "ManageAllScoreLogPosition"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/all-transaction-score",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTransactionScoreToWalletAdvertiser />,
        "AllTransactionScoreToWalletAdvertiser"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
